import { PreloadSelectedModulesList } from './preload-selected-modules-list';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule, XHRBackend, RequestOptions, Http, BrowserXhr } from '@angular/http';
import { AppComponent } from './app.component';
import { AppRoutingModule } from "./app-routing/app-routing.module";
import { MarkaService } from "app/service/marka.service";
import { ModelService } from "app/service/model.service";
import { TipService } from "app/service/tip.service";
import { IlanService } from "app/service/ilan.service";
import { GaleriService } from "app/service/galeri.service";
import { PilotGarageService } from "app/service/pilot-garage.service";
import { CustomHttpFactory } from "app/customhttp.factory";
import { CustomHttp } from "app/customhttp";
import { IhaleService } from "app/service/ihale.service";
import { AuthenticationGuard } from "app/authentication.guard";
import { AuthenticationService } from "app/service/authentication.service";
import { NotFoundComponent } from './not-found/not-found.component';
import { Router } from "@angular/router";
import { ProcessErrorComponent } from './process-error/process-error.component';
import { ProcessErrorActivateGuard } from "app/process-error/process-error-activate.guard";
import { KullaniciService } from "app/service/kullanici.service";
import { LocationStrategy, PathLocationStrategy } from "@angular/common";
import { NgProgressBrowserXhr, NgProgressModule } from 'ngx-progressbar';
import { SharedModule } from "app/shared.module";
import { AdminSigninComponent } from "app/admin/admin-signin/admin-signin.component";
import { AdminSignoutComponent } from "app/admin/admin-signout/admin-signout.component";
import { AdminAccountResultComponent } from "app/admin/admin-account-result/admin-account-result.component";
import { AdminAccountResultActivateGuard } from "app/admin/admin-account-result/admin-account-result-activate.guard";
import { PacketSyncService } from './service/packetsync.service';
import {FileUploadServiceService} from './file-upload-service.service';
import {HttpClientModule} from '@angular/common/http';
import {PanelIndexService} from './service/panelIndex.service';


@NgModule({
  declarations: [
    AppComponent,
    NotFoundComponent,
    ProcessErrorComponent,
    AdminSigninComponent,
    AdminSignoutComponent,
    AdminAccountResultComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    HttpClientModule,
    AppRoutingModule,
    NgProgressModule,
    SharedModule
  ],
  providers: [{ provide: LOCALE_ID, useValue: "tr-TR" },
              { provide: BrowserXhr, useClass: NgProgressBrowserXhr },
              { provide: LocationStrategy, useClass: PathLocationStrategy },
              MarkaService,
              ModelService,
              TipService,
              IlanService,
              PanelIndexService,
              GaleriService,
              PilotGarageService,
              IhaleService,
              KullaniciService,
              AuthenticationService,
              FileUploadServiceService,
              AuthenticationGuard,
              ProcessErrorActivateGuard,
              AdminAccountResultActivateGuard,
              {
                provide: CustomHttp,
                useFactory: CustomHttpFactory,
                deps: [Router, XHRBackend, RequestOptions]
              },
              PreloadSelectedModulesList,
              PacketSyncService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/Users/user/Desktop/otojet-git/OtojetUI-Spring-Admin-Project/src/app/app.module.ts